import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';

import { createLocationHelper } from '~/apps/shared/services/forms';
import { SearchableModelHelper } from '~/lib/forms/select';

import TransactionListFilter from '../../components/transactions/TransactionListFilter';


class TransactionFilter extends React.Component<any, any> {
  locHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.locHelper = createLocationHelper(this.refresh, this.getLocById);
  }

  refresh = () => {
    this.forceUpdate();
  }

  getLocById = (locId: string) => {
    return this.props.locations.entities[locId];
  }

  render = () => {
    const { onLocationChange, onFilter, filter } = this.props;

    return (
      <TransactionListFilter
        filter={filter}
        onLocationChange={onLocationChange}
        onFilter={onFilter}
        locationHelper={this.locHelper}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.shared.locations,
  };
};

export default connect(mapStateToProps)(TransactionFilter) as any;
